var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStepCurrent = function SvgStepCurrent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stepper/desktop/atom"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 9,
    cy: 9,
    r: 5,
    fill: "#1576E1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 9,
    cy: 9,
    r: 7,
    stroke: "#B4D3F7",
    strokeOpacity: 0.5,
    strokeWidth: 4
  }))));
};
export default SvgStepCurrent;